module.exports = __webpack_public_path__ + "img/20211217_invite_bonus.293837d1.jpg";